export default __webpack_public_path__ + "0314d7a.png";